module.exports = __webpack_public_path__ + "static/media/Beef_project_logo.5488d2b2.png";